import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

const VID = "mlfab_vid";
const ATTR = "mlfab_attr";

export function visitorId() {
  let v = localStorage.getItem(VID);
  if (!v) {
    v = (window.crypto?.randomUUID?.() || `${Math.random().toString(36).slice(2)}${Date.now()}`).replace(/-/g, "").slice(0, 32);
    localStorage.setItem(VID, v);
  }
  return v;
}

export function attribution() {
  if (!sessionStorage.getItem(ATTR)) {
    const q = new URLSearchParams(window.location.search);
    const ref = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : "";
    const utm = (k) => (q.get(k) || "").slice(0, 100);
    sessionStorage.setItem(ATTR, JSON.stringify({ referrer: ref.slice(0, 500), utm_source: utm("utm_source"), utm_medium: utm("utm_medium"), utm_campaign: utm("utm_campaign") }));
  }
  return { ...JSON.parse(sessionStorage.getItem(ATTR)), visitor_id: visitorId() };
}

export const trackVisit = (path) => http.post("/track/visit", { ...attribution(), path }).catch(() => {});

export const trackWhatsApp = (placement, product = "") =>
  http.post("/track/whatsapp", { visitor_id: visitorId(), page: window.location.pathname, placement, product }).catch(() => {});
